module.exports = __webpack_public_path__ + "img/phone-dload.4a71d481.png";